<template>
  <v-dialog max-width="1200px" v-model="inDialog" persistent>
    <v-card>
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
                $t(formCreateName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-text-field
                  type="text"
                  :label="$t('lessonId')"
                  v-model.trim="item.lessonId"
                  name="className"
                  v-validate="'required'"
                  maxLength="500"
                  :error-messages="errors.first('lessonId')"
                  :data-vv-as="$t('lessonId')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-text-field
                  type="text"
                  :label="$t('week')"
                  v-model.trim="item.week"
                  name="week"
                  v-validate="'required'"
                  maxLength="500"
                  :error-messages="errors.first('week')"
                  :data-vv-as="$t('week')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-text-field
                  type="text"
                  :label="$t('name')"
                  v-model.trim="item.name"
                  name="name"
                  v-validate="'required'"
                  maxLength="500"
                  :error-messages="errors.first('name')"
                  :data-vv-as="$t('name')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-text-field
                  type="text"
                  :label="$t('vocalbulary')"
                  v-model.trim="item.vocalbulary"
                  name="vocalbulary"
                  v-validate="'required'"
                  maxLength="500"
                  :error-messages="errors.first('vocalbulary')"
                  :data-vv-as="$t('vocalbulary')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-text-field
                  type="text"
                  :label="$t('sentence')"
                  v-model.trim="item.sentence"
                  name="sentence"
                  v-validate="''"
                  maxLength="500"
                  :error-messages="errors.first('sentence')"
                  :data-vv-as="$t('sentence')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-text-field
                  type="text"
                  :label="$t('target')"
                  v-model.trim="item.target"
                  name="target"
                  v-validate="'required'"
                  maxLength="500"
                  :error-messages="errors.first('target')"
                  :data-vv-as="$t('target')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-text-field
                  type="text"
                  :label="$t('urlVideo')"
                  v-model.trim="item.urlVideo"
                  name="urlVideo"
                  v-validate="''"
                  maxLength="500"
                  :error-messages="errors.first('urlVideo')"
                  :data-vv-as="$t('urlVideo')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-text-field
                  type="text"
                  :label="$t('urlPdf')"
                  v-model.trim="item.urlPdf"
                  name="urlPdf"
                  v-validate="''"
                  maxLength="500"
                  :error-messages="errors.first('urlPdf')"
                  :data-vv-as="$t('urlPdf')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-text-field
                  type="text"
                  :label="$t('urlVideoMobi')"
                  v-model.trim="item.urlVideoMobi"
                  name="urlVideoMobi"
                  v-validate="''"
                  maxLength="500"
                  :error-messages="errors.first('urlVideoMobi')"
                  :data-vv-as="$t('urlVideoMobi')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-text-field
                  type="text"
                  :label="$t('urlPdfMobi')"
                  v-model.trim="item.urlPdfMobi"
                  name="urlPdfMobi"
                  v-validate="''"
                  maxLength="500"
                  :error-messages="errors.first('urlPdfMobi')"
                  :data-vv-as="$t('urlPdfMobi')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-text-field
                  type="text"
                  :label="$t('stickerFinishUrl')"
                  v-model.trim="item.stickerFinishUrl"
                  name="stickerFinishUrl"
                  v-validate="''"
                  maxLength="500"
                  :error-messages="errors.first('stickerFinishUrl')"
                  :data-vv-as="$t('stickerFinishUrl')"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
      <div style="text-align: right">
        <v-btn color="primary" @click="onSave">
          <v-icon dark left>save</v-icon>
          {{ $t("lang.common.save") }}
        </v-btn>
        <v-btn color="error" @click="onCancel">
          <v-icon dark left>cancel</v-icon>
          {{ $t("lang.common.cancel") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {message} from "../../../services";
import axios from "axios";
import {areaContants} from "@/constants";
import moment from "moment/moment";

export default {
  name: "school-create-form",
  components: {message, axios},
  props: {
    propsItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    cDialog: {
      type: Boolean,
      default: false,
    },
    formCreateName: {
      type: String,
      default: '',
    },


  },
  data: () => {
    return {
      areaStatus: areaContants.areaStatus,
      item: {
        lessonId: "",
        week: "",
        name: "",
        vocalbulary: "",
        sentence: "",
        target: "",
        urlVideo: "",
        urlPdf: "",
        stickerFinishUrl: "",
      },
      inDialog: false,
    };
  },
  watch: {
    propsItem: {
      handler(value) {
        if (value !== null) {
          this.item =  Object.assign({}, value);
        } else {
          this.resetFrom();
        }
      },
      deep: true,
    },
    cDialog(value) {
      this.inDialog = value;
    },
    inDialog(value) {
      if (!value) {
        this.$emit("closeCreateDialog", "");
      }
    },
  },
  methods: {
    resetFrom: function () {
      this.item = Object.assign({}, {"isActive": 1});
    },
    onCancel: function () {
      this.$emit("closeCreateDialog", "");
    },
    onSave: function () {
      this.$validator.validate().then((valid) => {
        if (!valid) {
          message.error(this.$t("lang.common.validate_fail"));
          return;
        }
        axios
            .post(
                process.env.VUE_APP_API_URL +
                "/schoolTutorial/save",
                this.item
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                    this.resetFrom();
                    this.onCancel();
                  } else {
                    let msg = data.description;
                    message.error(this.$t(msg));
                  }
                },
                (error) => {
                  console.log(error);
                }
            );
      });
    },

  },
  created() {
  },
};
</script>
